import { createSlice } from "@reduxjs/toolkit"

export const hideSideBar = createSlice({
    name: "hide",
    initialState: false, // Initial state is set to false
    reducers: {
        hide: () => true, // Action to hide (set state to true)
        show: () => false, // Action to show (set state to false)
    },
})

export const { hide, show } = hideSideBar.actions
export default hideSideBar.reducer
